module.exports = __webpack_public_path__ + "img/122ne.fb3e5158.svg";